import { TExcludedCommoditiesSchema } from './schema/ExcludedCommoditiesSchema'
import { IExcludedCommodities } from './types'

export const formKeyToCommodity: Record<keyof TExcludedCommoditiesSchema, IExcludedCommodities> = {
  alcohol: IExcludedCommodities.ALCOHOL,
  babyFood: IExcludedCommodities.BABY_FOOD,
  cosmetic: IExcludedCommodities.COSMETIC,
  electronic: IExcludedCommodities.ELECTRONIC,
  garment: IExcludedCommodities.GARMENT,
  jewelry: IExcludedCommodities.JEWELRY,
  meat: IExcludedCommodities.MEAT,
  medication: IExcludedCommodities.MEDICATION,
  metal: IExcludedCommodities.METAL,
  seafood: IExcludedCommodities.SEAFOOD,
  tobacco: IExcludedCommodities.TOBACCO,
}
